import React from 'react';

import Grid, { GridItem } from '@marvelapp/marvel-ui/grid';
import Spacing from '@marvelapp/marvel-ui/spacing';

import assets from 'marketing-website/configs/pages/sketch/assets';
import Feature from 'marketing-website/components/modules/Feature';
import HeadingBlock from 'marketing-website/components/modules/HeadingBlock';

export default function FeaturesBlockList() {
  return (
    <Spacing type="padding" size="l" sizeM="0" position="bottom">
      <Spacing type="margin" size="m" position="bottom">
        <HeadingBlock
          maxWidth={620}
          alignContent="center"
          alignM="center"
          title="Strengthen product teams and transform workflows"
          paragraphSize="m"
          copy={
            <span>
              Consolidate the entire design process with Marvel + Sketch. Sync,
              create, record and bridge the gap between design and development
              with access to Handoff and watch your teams efficiency reach new
              levels.
            </span>
          }
          justifyContent="center"
          justifyM="center"
          size="l"
        />
      </Spacing>
      <Grid columns={3} size="l">
        <GridItem columnSpan={3} columnSpanM={1}>
          <Feature
            {...assets.devices}
            title="Access anywhere"
            copy="Your designs are no longer tied to one device. Access and collaborate anywhere with our web platform, iOS and Android apps."
            maxWidth={365}
            fontWeight="semibold"
          />
        </GridItem>
        <GridItem columnSpan={3} columnSpanM={1}>
          <Feature
            {...assets.record}
            title="Play, record, share"
            copy="Play prototypes without leaving Sketch to double check flows, then record videos of your prototype flow to share with clients and stakeholders."
            maxWidth={365}
            fontWeight="semibold"
          />
        </GridItem>
        <GridItem columnSpan={3} columnSpanM={1}>
          <Feature
            {...assets.handoff}
            title="Developer ready"
            copy="Every artboard you add from Sketch is automatically transformed into code, specs and assets, ready for developers to start working."
            maxWidth={365}
            fontWeight="semibold"
          />
        </GridItem>
      </Grid>
    </Spacing>
  );
}



// WEBPACK FOOTER //
// ./src/pages/sketch/FeaturesBlockList.js